import { Map } from "immutable"

import {
    NOTIFICATION_LIST_REQUEST as LIST_REQUEST,
    NOTIFICATION_LIST_RESPONSE as LIST_RESPONSE,
    NOTIFICATION_LIST_CACHED_RESPONSE as LIST_CACHED_RESPONSE,
    NOTIFICATION_LIST_ERROR_RESPONSE as LIST_ERROR_RESPONSE,
    NOTIFICATION_ITEM_DELETE_RESPONSE as ITEM_DELETE_RESPONSE,
} from "../../actions/action-types"
import buildPagingReducer from "./build-paging-reducer"

export const defaultSearchCriteria = Map({})

export default buildPagingReducer(
    {
        LIST_REQUEST,
        LIST_RESPONSE,
        LIST_CACHED_RESPONSE,
        LIST_ERROR_RESPONSE,
        ITEM_DELETE_RESPONSE,
    },
    defaultSearchCriteria
)
